import { useRef, useEffect } from 'react';

export const useStableArray = <T>(array: T[]): T[] => {
  const prevArrayRef = useRef<T[]>(array);

  useEffect(() => {
    const isSame =
      prevArrayRef.current.length === array.length &&
      prevArrayRef.current.every((val, index) => val === array[index]);

    if (!isSame) {
      prevArrayRef.current = array;
    }
  }, [array]);

  return prevArrayRef.current;
};
